import React, { useEffect, useState } from 'react';
import TarsAvatar from './TarsAvatar';

interface ChatFABProps {
  onClick: () => void;
}

// TarsAvatar's `size` prop drives both CSS sizing and the JS sprite-sheet
// background-position math, so the responsive size change has to be a real
// number swap (via matchMedia), not a Tailwind breakpoint on the element.
const AVATAR_SIZE_MOBILE = 56;
const AVATAR_SIZE_DESKTOP = 84;
const DESKTOP_QUERY = '(min-width: 640px)';

const ChatFAB: React.FC<ChatFABProps> = ({ onClick }) => {
  const [avatarSize, setAvatarSize] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia(DESKTOP_QUERY).matches
      ? AVATAR_SIZE_DESKTOP
      : AVATAR_SIZE_MOBILE
  );

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY);
    const update = () => setAvatarSize(mql.matches ? AVATAR_SIZE_DESKTOP : AVATAR_SIZE_MOBILE);
    update();
    mql.addEventListener('change', update);
    return () => mql.removeEventListener('change', update);
  }, []);

  return (
    <button
      onClick={onClick}
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 flex items-center gap-3 animate-fade-in animate-slide-up group"
      aria-label="Open chat with TARS"
      data-lens-exclude
    >
      <span className="hidden sm:inline-block font-mono text-sm text-dev-accent-cyan bg-dev-bg-card border border-dev-border rounded-lg px-3.5 py-2.5 shadow-dev-md group-hover:border-dev-accent-cyan/40 group-hover:-translate-y-0.5 transition-all duration-300">
        <span className="text-dev-text-dimmed">&gt;</span> ask me about parth
        <span className="animate-cursor-blink">_</span>
      </span>
      <span className="relative">
        <TarsAvatar size={avatarSize} />
        <span className="absolute top-1 right-1 sm:top-1.5 sm:right-1.5 w-2.5 h-2.5 sm:w-3 sm:h-3 bg-dev-success rounded-full border-2 border-dev-bg animate-pulse"></span>
      </span>
    </button>
  );
};

export default ChatFAB;
